/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import * as l10n from './NamesHelper.l10n';

const { ENGLISH: dictionary, ...l10nKeys } = l10n;

angular.module('aviApp').factory('NamesHelper', ['l10nService', function(l10nService) {
    // todo -- break this into a couple of objects, combine into single object,
    // and then return that single object
    const helper = {};

    l10nService.registerSourceBundles(dictionary);

    helper.commonDict = {
        dos: 'DoS',
        req: 'Requests',
        pkts: 'Packets',
        resp: 'Response',
        lb: 'LB',
        udp: 'UDP',
        rx: 'RX',
        tx: 'TX',
        vs: 'VS',
    };

    helper.dict = {
        // Summary names
        new_connections: {
            title: l10nKeys.newConnectionsTitle,
            color: 1,
        },
        new_requests: {
            title: l10nKeys.newRequestsTitle,
            color: 1,
        },
        // Groups
        'end_to_end.vs': {
            title: l10nKeys.endToEndTimingTitle,
            color: 1,
        },
        'end_to_end.pool': {
            title: l10nKeys.endToEndTimingTitle,
            color: 1,
        },
        // VS insights page
        'l7_client.avg_satisfactory_responses': {
            title: l10nKeys.averageSatisfactoryResponsesTitle,
            color: 1,
        },
        'l7_client.avg_tolerated_responses': {
            title: l10nKeys.averageToleratedResponsesTitle,
            color: 'warning',
        },
        'l7_client.avg_frustrated_responses': {
            title: l10nKeys.averageFrustratedResponsesTitle,
            color: 'bad',
        },
        'l7_server.avg_satisfactory_responses': {
            title: l10nKeys.averageSatisfactoryResponsesTitle,
            color: 1,
        },
        'l7_server.avg_tolerated_responses': {
            title: l10nKeys.averageToleratedResponsesTitle,
            color: 'warning',
        },
        'l7_server.avg_frustrated_responses': {
            title: l10nKeys.averageFrustratedResponsesTitle,
            color: 'bad',
        },
        'l4_client.apdexc': {
            title: l10nKeys.connectionApdexTitle,
            color: 2,
        },
        'l7_client.apdexr': {
            title: l10nKeys.responseApdexTitle,
            color: 3,
        },
        'l4_client.avg_l4_client_latency': {
            title: l10nKeys.clientLatencyTitle,
            color: 6,
        },
        health_performance_score: {
            title: l10nKeys.performanceTitle,
            color: 1,
        },
        'l7_server.avg_total_requests': {
            title: l10nKeys.requestsTitle,
            color: 2,
        },
        'l4_client.apdexrtt': {
            title: l10nKeys.apdexRttTitle,
            color: 7,
        },
        Total: {
            title: l10nKeys.totalTitle,
            color: 2,
        },
        total: {
            title: l10nKeys.totalTitle,
            color: 1,
        },
        total5: {
            title: l10nKeys.totalTitle,
            color: 5,
        },
        health_resources_score: {
            title: l10nKeys.resourcePenaltyTitle,
            color: 'bad',
        },
        'l4_client.avg_complete_conns': {
            title: l10nKeys.connsTitle,
            color: 2,
        },
        'l4_client.avg_new_established_conns': {
            title: l10nKeys.openConnsTitle,
            color: 4,
        },
        'l4_client.avg_connections_dropped': {
            title: l10nKeys.droppedConnectionsTitle,
            color: 'bad',
        },
        'l4_client.avg_lossy_connections': {
            title: l10nKeys.lossyConnectionsTitle,
            color: 'warning',
        },
        'l7_client.avg_resp_4xx': {
            title: l10nKeys._4xxTitle,
            color: 'bad',
        },
        'l4_server.avg_resp_4xx': {
            title: l10nKeys.server4xxTitle,
            color: 'bad',
        },
        'l7_server.avg_resp_4xx': {
            title: l10nKeys.server4xxTitle,
            color: 'bad',
        },
        'l7_server.avg_resp_5xx': {
            title: l10nKeys.server5xxTitle,
            color: 'warning',
        },
        'l4_server.avg_resp_5xx': {
            title: l10nKeys.server5xxTitle,
            color: 'warning',
        },
        'l7_client.avg_resp_5xx': {
            title: '5xx',
            color: 'warning',
        },
        'l7_client.rum_apdexr': {
            title: l10nKeys.pageLoadApdexTitle,
            color: 7,
        },
        'l7_server.avg_error_responses': {
            title: l10nKeys.requestErrorsTitle,
            color: 'bad',
        },
        'l7_server.pct_response_errors': {
            title: l10nKeys.requestErrorsPercentageTitle,
            color: 'bad',
        },
        'l7_client.avg_error_responses': {
            title: l10nKeys.requestErrorsTitle,
            color: 'bad',
        },
        'l7_server.apdexr': {
            title: l10nKeys.responseApdexTitle,
            color: 7,
        },
        'l4_server.apdexc': {
            title: l10nKeys.connectionApdexTitle,
            color: 7,
        },
        'l4_server.avg_uptime': {
            title: l10nKeys.averageUptimeTitle,
            color: 1,
        },
        'l7_server.sum_get_reqs': {
            title: l10nKeys.getTitle,
            color: 4,
        },
        'l7_server.sum_post_reqs': {
            title: l10nKeys.postTitle,
            color: 7,
        },
        'l7_server.sum_other_reqs': {
            title: l10nKeys.othersTitle,
            color: 1,
        },
        'l7_server.avg_resp_1xx': {
            title: l10nKeys.oneXxInfoTitle,
            color: 2,
        },
        'l7_server.avg_resp_2xx': {
            title: l10nKeys.twoXxOkTitle,
            color: 3,
        },
        'l7_server.avg_resp_3xx': {
            title: l10nKeys.threeXxRedirectTitle,
            color: 4,
        },
        'l4_server.max_open_conns': {
            title: l10nKeys.openConnsTitle,
            color: 4,
        },
        'l4_server.avg_complete_conns': {
            title: l10nKeys.newConnectionsTitle,
            color: 1,
        },
        'l4_server.avg_bandwidth': {
            title: l10nKeys.throughputTitle,
            color: 2,
        },
        'collection.server_total_satisfactory_responses': {
            title: l10nKeys.satisfactoryResponsesTitle,
            color: 1,
        },
        'collection.server_total_tolerated_responses': {
            title: l10nKeys.toleratedResponsesTitle,
            color: 'warning',
        },
        'collection.server_total_frustrated_responses': {
            title: l10nKeys.frustratedResponsesTitle,
            color: 'bad',
        },
        'l4_server.avg_lossy_connections': {
            title: l10nKeys.lossyConnectionsTitle,
            color: 'warning',
        },
        'l4_server.avg_errored_connections': {
            title: l10nKeys.badConnectionsTitle,
            color: 'bad',
        },
        'l4_client.max_open_conns': {
            title: l10nKeys.openConnsTitle,
            color: 2,
        },
        'l7_client.pct_response_errors': {
            title: l10nKeys.requestErrorsPercentageTitle,
            color: 'bad',
        },
        'collection.virtualservice_total_satisfactory_responses': {
            title: l10nKeys.satisfiedResponsesTitle,
            color: 1,
        },
        'collection.virtualservice_total_frustrated_responses': {
            title: l10nKeys.frustratedResponsesTitle,
            color: 'bad',
        },
        'collection.virtualservice_total_tolerated_responses': {
            title: l10nKeys.toleratedResponsesTitle,
            color: 'warning',
        },
        'l4_client.avg_errored_connections': {
            title: l10nKeys.badConnectionsTitle,
            color: 'bad',
        },
        'l7_client.sum_post_reqs': {
            title: l10nKeys.postRequestsTitle,
            color: 2,
        },
        'l7_client.sum_get_reqs': {
            title: l10nKeys.getRequestsTitle,
            color: 3,
        },
        'l7_client.sum_other_reqs': {
            title: l10nKeys.otherRequestsTitle,
            color: 4,
        },
        'l7_client.avg_client_data_transfer_time': {
            title: l10nKeys.dataTransferTitle,
            color: 3,
        },
        'l7_server.avg_application_response_time': {
            title: l10nKeys.appResponseTitle,
            color: 6,
        },
        'l4_client.avg_total_rtt': {
            title: l10nKeys.clientRttTitle,
            color: 1,
        },
        'l4_server.avg_total_rtt': {
            title: l10nKeys.serverRttTitle,
            color: 2,
        },
        // Response Codes:
        'l7_server.response_code_4xx': {
            title: l10nKeys.fourXxErrorsTitle,
            color: 'bad',
        },
        'l7_server.response_code_5xx': {
            title: l10nKeys.fiveXxErrorsTitle,
            color: 'warning',
        },
        'l7_client.response_code_4xx': {
            title: l10nKeys.aviGenerated4xxTitle,
            color: 1,
        },
        'l7_client.response_code_5xx': {
            title: l10nKeys.aviGenerated5xxTitle,
            color: 'warning',
        },
        'se_stats.avg_cpu_usage': {
            title: l10nKeys.cpuUsageTitle,
            color: 3,
        },
        'se_if.avg_bandwidth': {
            title: l10nKeys.throughputTitle,
            color: 2,
        },
        'se_stats.avg_connection_mem_usage': {
            title: l10nKeys.connectionMemoryUsageTitle,
            color: 1,
        },
        'se_stats.avg_mem_usage': {
            title: l10nKeys.memoryUsageTitle,
            color: 6,
        },
        'se_stats.avg_packet_buffer_usage': {
            title: l10nKeys.bufferUsageTitle,
            color: 3,
        },
        'se_stats.avg_ssl_session_cache_usage': {
            title: l10nKeys.sslCacheUsageTitle,
            color: 4,
        },
        'se_stats.avg_disk1_usage': {
            title: l10nKeys.disk1UsageTitle,
            color: 7,
        },
        'se_stats.avg_persistent_table_usage': {
            title: l10nKeys.persistentTableUsageTitle,
            color: 1,
        },
        'se_stats.max_se_bandwidth': {
            title: l10nKeys.maxUsageTitle,
            color: 2,
        },
        'se_stats.avg_connections': {
            title: l10nKeys.connsTitle,
            color: 6,
        },
        'se_stats.pct_connections_dropped': {
            title: l10nKeys.droppedConnsPercentageTitle,
            color: 3,
        },
        'se_stats.pct_syn_cache_usage': {
            title: l10nKeys.synCacheUsageTitle,
            color: 1,
        },
        'se_stats.avg_rx_pkts_dropped': {
            title: l10nKeys.rxPacketsDropTitle,
            color: 4,
        },
        'se_stats.avg_rx_bytes_dropped': {
            title: l10nKeys.rxBytesDropTitle,
            color: 4.2,
        },
        'se_stats.avg_tx_bandwidth': {
            title: l10nKeys.txThroughputTitle,
            color: 7.2,
        },
        'se_stats.max_num_vs': {
            title: l10nKeys.vsesTimeSeriesTitle,
            color: 6,
        },
        'se_stats.avg_dynamic_mem_usage': {
            title: l10nKeys.dynamicMemoryUsageTitle,
            color: 4.2,
        },
        serviceengine: {
            title: l10nKeys.serviceEngineTitle,
            color: 3,
            small: 'SE',
        },
        pool: {
            title: l10nKeys.poolTitle,
            color: 4,
            small: 'Pool',
        },
        virtualservice: {
            title: l10nKeys.virtualServiceTitle,
            color: 7,
            small: 'VS',
        },
        anomaly_penalty: {
            title: l10nKeys.anomalyPenaltyTitle,
            color: 'bad',
            small: 'Anomaly',
        },
        resources_penalty: {
            title: l10nKeys.resourcePenaltyTitle,
            color: 'warning',
            small: 'Resource',
        },
        security_penalty: {
            title: l10nKeys.securityPenaltyTitle,
            color: 'bad',
            small: 'Security',
        },
        performance_value: {
            title: l10nKeys.performanceScoreTitle,
            color: 1,
            small: 'Performance',
        },
        health_score: {
            title: l10nKeys.healthScoreTitle,
            color: 2,
            small: 'Health',
        },
        'l7_client.avg_client_txn_latency': {
            title: l10nKeys.clientTxnLatencyTitle,
            color: 7,
        },
        'l4_client.avg_rx_pkts': {
            title: l10nKeys.rxPacketsTitle,
            color: 4,
        },
        'l4_client.avg_tx_pkts': {
            title: l10nKeys.txPacketsTitle,
            color: 3,
        },
        'l4_client.avg_bandwidth': {
            title: l10nKeys.throughputTitle,
            color: 1,
        },
        'l4_client.max_num_active_se': {
            title: l10nKeys.numberServiceEnginesTitle,
            color: 1,
        },
        health_anomaly_score: {
            title: l10nKeys.anomalyScoreTitle,
            color: 'bad',
        },
        'l4_server.avg_new_established_conns': {
            title: l10nKeys.newConnectionsTitle,
            color: 1,
        },
        'l7_client.avg_total_requests': {
            title: l10nKeys.totalRequestsTitle,
            color: 3,
        },
        'l7_client.avg_complete_responses': {
            title: l10nKeys.requestsTitle,
            color: 1,
            chartSettings: {
                excludeTotals: true,
            },
        },
        'l7_server.avg_complete_responses': {
            title: l10nKeys.requestsTitle,
            color: 1,
        },
        'vm_stats.avg_net_usage': {
            title: l10nKeys.netUsageTitle,
            color: 1,
        },
        'vm_stats.avg_net_received': {
            title: l10nKeys.netReceivedTitle,
            color: 2,
        },
        'vm_stats.avg_cpu_usage': {
            title: 'CPU',
            color: 3,
        },
        'l4_client.pct_connection_errors': {
            title: l10nKeys.connectionErrorsTitle,
            color: 4,
        },
        'l7_client.avg_resp_1xx': {
            title: '1xx',
            color: 1,
        },
        'l7_client.avg_resp_2xx': {
            title: '2xx',
            color: 2,
        },
        'l7_client.avg_resp_3xx': {
            title: '3xx',
            color: 3,
        },
        'l7_server.avg_resp_4xx_errors': {
            title: l10nKeys._4xxTitle,
            color: 'bad',
        },
        'l7_server.avg_resp_5xx_errors': {
            title: '5xx',
            color: 'warning',
        },
        'l7_client.avg_resp_4xx_avi_errors': {
            title: 'Avi 4xx',
            color: 5,
        },
        'l7_client.avg_resp_5xx_avi_errors': {
            title: 'Avi 5xx',
            color: 7,
        },
        'server.vm_stats.avg_cpu_usage': {
            title: 'CPU',
            color: 4,
        },
        'server.vm_stats.avg_mem_usage': {
            title: l10nKeys.memoryTitle,
            color: 6,
        },
        'server.vm_stats.avg_virtual_disk_throughput_usage': {
            title: l10nKeys.diskBandwidthTitle,
            color: 7.2,
        },
        'vm_stats.avg_virtual_disk_throughput_usage': {
            title: l10nKeys.diskBandwidthTitle,
            color: 7.2,
        },
        'vm_stats.avg_mem_usage': {
            title: l10nKeys.memoryTitle,
            color: 6,
        },
        'l7_client.avg_ssl_auth_rsa': {
            title: 'RSA',
            color: 2,
        },
        'l7_client.avg_ssl_auth_ecdsa': {
            title: 'EC',
            color: 7,
        },
        'l7_client.avg_ssl_handshakes_non_pfs': {
            title: 'Non-PFS',
            color: 2,
        },
        'l7_client.avg_ssl_auth_dsa': {
            title: 'DSA',
            color: 4,
        },
        'l7_client.avg_ssl_rsa_pfs': {
            title: 'RSA PFS',
            color: 7,
        },
        'l7_client.avg_ssl_rsa_non_pfs': {
            title: 'Non-PFS',
            color: 6,
        },
        'l7_client.avg_ssl_non_pfs': {
            title: 'RSA Non-PFS',
            color: 6,
        },
        'l7_client.avg_ssl_ecdsa_pfs': {
            title: 'ECDSA PFS',
            color: 4,
        },
        'l7_client.avg_ssl_ecdsa_non_pfs': {
            title: 'ECDSA Non-PFS',
            color: 1,
        },
        'l7_client.avg_ssl_ver_tls10': {
            title: 'TLS 1.0',
            color: 6,
        },
        'l7_client.avg_ssl_ver_tls11': {
            title: 'TLS 1.1',
            color: 1,
        },
        'l7_client.avg_ssl_ver_tls12': {
            title: 'TLS 1.2',
            color: 7,
        },
        'l7_client.avg_ssl_ver_tls13': {
            title: 'TLS 1.3',
            color: 4,
        },
        'l7_client.avg_ssl_connections': {
            title: l10nKeys.transactionsTitle,
            color: 2,
            chartSettings: {
                excludeTotals: true,
            },
        },
        'l7_client.avg_ssl_handshakes_new': {
            title: l10nKeys.newSslSessionsTitle,
            color: 1,
        },
        'l7_client.avg_ssl_handshakes_reused': {
            title: l10nKeys.reusedSslSessionsTitle,
            color: 3,
        },
        'l7_client.avg_ssl_handshake_protocol_errors': {
            title: l10nKeys.sslProtocolErrorsTitle,
            color: 4,
        },
        'l7_client.avg_ssl_handshake_network_errors': {
            title: l10nKeys.sslNetworkErrorsTitle,
            color: 5,
        },
        'l7_client.avg_ssl_handshakes_timedout': {
            title: l10nKeys.sslTimeoutsTitle,
            color: 6,
        },
        'l7_client.avg_ssl_errors': {
            title: l10nKeys.failedTransactionsTitle,
            color: 2,
        },
        'l7_client.pct_ssl_failed_connections': {
            title: l10nKeys.failedTransactionsTitle,
            color: 2,
        },
        'l7_client.avg_ssl_handshakes_pfs': {
            title: 'PFS',
            color: 1,
        },
        'l7_client.avg_ssl_kx_ecdh': {
            title: 'ECDH',
            color: 2,
        },
        'l7_client.avg_ssl_kx_dh': {
            title: 'DH',
            color: 3,
        },
        'l7_client.avg_ssl_kx_rsa': {
            title: 'RSA',
            color: 4,
        },
        'l4_client.avg_network_dos_attacks': {
            title: l10nKeys.l4AttacksTitle,
            color: 6,
        },
        'l4_client.avg_application_dos_attacks': {
            title: l10nKeys.l7AttacksTitle,
            color: 2,
        },
        'dos.sum_attack_duration': {
            title: l10nKeys.attackDurationTitle,
            color: 3,
        },
        'l4_client.avg_policy_drops': {
            title: l10nKeys.blockedConnectionsTitle,
            color: 3,
        },
        avg_attack_count_attack: {
            title: l10nKeys.numberOfAttacksTitle,
            color: 2,
        },
        avg_attack_count_ipgroup: {
            title: l10nKeys.numberOfAttacksTitle,
            color: 2,
        },
        avg_attack_count_url: {
            title: l10nKeys.numberOfAttacksTitle,
            color: 2,
        },
        avg_attack_count_blocked: {
            title: l10nKeys.blockedTitle,
            color: 2,
        },
        attack_level: {
            title: l10nKeys.attackLevelTitle,
            color: 2,
        },
        'l4_client.avg_dos_attacks': {
            title: l10nKeys.dosAttacksTitle,
            color: 2,
        },
        'l4_client.pct_pkts_dos_attacks': {
            title: l10nKeys.packetsDosAttacksTitle,
            color: 2,
        },
        'l4_client.pct_application_dos_attacks': {
            title: l10nKeys.applicationDosAttacksTitle,
            color: 2,
        },
        'l4_client.pct_dos_rx_bytes': {
            title: l10nKeys.dosRxBytesTitle,
            color: 2,
        },
        'l4_client.pct_policy_drops': {
            title: l10nKeys.policyDropsTitle,
            color: 2,
        },
        'l4_client.pct_connections_dos_attacks': {
            title: l10nKeys.connectionDosAttacksTitle,
            color: 2,
        },
        'l4_client.pct_dos_bandwidth': {
            title: l10nKeys.dosBandwidthTitle,
            color: 2,
        },
        'l4_server.sum_lb_fail_count': {
            title: l10nKeys.lbFailCountTitle,
            color: 2,
        },
        'l4_server.avg_est_capacity': {
            title: l10nKeys.estimatedCapacityTitle,
            color: 2,
        },
        'l4_server.avg_available_capacity': {
            title: l10nKeys.availableCapacityTitle,
            color: 1,
        },
        'dns_client.avg_complete_queries': {
            title: l10nKeys.dnsQueriesTitle,
            color: 4,
            chartSettings: {
                excludeTotals: true,
            },
        },
        'dns_client.avg_resp_type_a': {
            title: 'A',
            color: 1,
        },
        'dns_client.avg_resp_type_aaaa': {
            title: 'AAAA',
            color: 2,
        },
        'dns_client.avg_resp_type_ns': {
            title: 'NS',
            color: 3,
        },
        'dns_client.avg_resp_type_srv': {
            title: 'SRV',
            color: 4,
        },
        'dns_client.avg_resp_type_mx': {
            title: 'MX',
            color: 6,
        },
        'dns_client.avg_resp_type_other': {
            title: l10nKeys.otherTitle,
            color: 7,
        },
        'dns_client.pct_errored_queries': {
            title: l10nKeys.errorsPercentageTitle,
            color: 'bad',
        },
        'dns_client.avg_errored_queries': {
            title: l10nKeys.errorsSecTitle,
            color: 'bad',
        },
        'dns_client.avg_tcp_queries': {
            title: l10nKeys.tcpQueriesTitle,
            color: 2,
        },
        'dns_client.avg_udp_queries': {
            title: l10nKeys.udpQueriesTitle,
            color: 4,
        },
        'dns_client.avg_udp_passthrough_queries': {
            color: 1,
        },
        'dns_client.avg_tcp_passthrough_queries': {
            color: 2,
        },
        'dns_client.avg_udp_passthrough_resp_time': {
            title: l10nKeys.updPassthroughResponseTimeTitle,
            color: 3.2,
        },
        'dns_client.avg_local_responses': {
            color: 3,
        },
        'dns_client.avg_gslbpool_member_not_available': {
            title: l10nKeys.gslbPoolMemberNotAvailableTitle,
            color: 'bad',
        },
        'dns_client.avg_invalid_queries': {
            title: l10nKeys.invalidQueriesTitle,
            color: 2.2,
        },
        'dns_client.avg_domain_lookup_failures': {
            title: l10nKeys.invalidDomainsTitle,
            color: 'warning',
        },
        'dns_client.avg_unsupported_queries': {
            title: l10nKeys.unsupportedRequestsTitle,
            color: 6,
        },
        'dns_client.avg_tcp_passthrough_errors': {
            title: l10nKeys.tcpPassthroughErrorsTitle,
        },
        'dns_client.avg_udp_passthrough_errors': {
            title: l10nKeys.udpPassthroughErrorsTitle,
        },
        'tenant_stats.avg_num_backend_servers': {
            title: l10nKeys.backendServersTitle,
            color: 2,
        },
        'tenant_stats.avg_num_se_cores': {
            title: l10nKeys.seCoresAvailableTitle,
            color: 3,
        },
        'tenant_stats.max_total_se_throughput': {
            title: l10nKeys.throughputAcrossSesTitle,
            color: 4,
        },
        'tenant_stats.sum_total_vs_client_bytes': {
            title: l10nKeys.throughputAcrossVirtualServicesTitle,
            color: 5,
        },
        'tenant_stats.max_num_ses': {
            title: l10nKeys.maxSeHostsTitle,
            color: 6,
        },
        'tenant_stats.avg_num_ses': {
            title: l10nKeys.averageSeHostsTitle,
            color: 1.2,
        },
        'tenant_stats.max_num_sockets': {
            title: l10nKeys.maxSeSocketsTitle,
            color: 2.2,
        },
        'tenant_stats.avg_num_sockets': {
            title: l10nKeys.averageSeSocketsTitle,
            color: 3.2,
        },
        'l7_client.avg_waf_attacks': {
            title: l10nKeys.wafAttacksTitle,
            color: 4.2,
        },
        'l7_client.pct_waf_attacks': {
            title: l10nKeys.wafAttacksPercentageTitle,
            color: 7.2,
        },
        'l7_client.avg_total_http2_requests': {
            title: l10nKeys.http2RequestsTitle,
            color: 1.2,
        },
        'icap_stats.avg_modified': {
            title: l10nKeys.icapRequestsModifiedTitle,
            color: 2,
        },
        'icap_stats.avg_passed': {
            title: l10nKeys.icapRequestsPassedTitle,
            color: 1,
        },
        'icap_stats.avg_blocked': {
            title: l10nKeys.blockedTitle,
            color: 3.2,
        },
        'icap_stats.avg_server_error': {
            title: l10nKeys.icapRequestsServerErrorTitle,
            color: 7,
        },
        'icap_stats.avg_internal_error': {
            title: l10nKeys.icapRequestsInternalErrorTitle,
            color: 6,
        },
        'icap_stats.avg_timedout': {
            title: l10nKeys.timeoutSeriesTitle,
            color: 5,
        },
        'icap_stats.pct_error': {
            title: l10nKeys.errorsPercentageTitle,
            color: 'bad',
        },
        'bot.avg_all_bots': {
            title: l10nKeys.botTitle,
            color: 3,
        },
    };

    const regularColors = [
        'green',
        'blue',
        'purple',
        'grape',
        'yellow',
        'fuchsia',
        'green-two',
        'blue-two',
        'purple-two',
        'grape-two',
        'fuchsia-two', //10
    ];

    helper.numToString = {
        1: regularColors[0], // green
        2: regularColors[1], // blue
        3: regularColors[2], // purple
        4: regularColors[3], // grape
        5: 'grey',
        6: regularColors[4], // yellow
        7: regularColors[5], // fuchsia
        1.2: regularColors[6], // green-two
        2.2: regularColors[7], // blue-two
        3.2: regularColors[8], // purple-two
        4.2: regularColors[9], // grape-two
        7.2: regularColors[10], // fuchsia-two
        bad: 'bad',
        warning: 'warning',
    };

    /**
     * Returns color class name buy group index.
     * @param {number=} index
     * @returns {string}
     * @public
     */
    helper.getColorClassNameByGroupIndex = function(index = 0) {
        const
            { length: numberOfColors } = regularColors,
            groupIndex = index - Math.floor(index / numberOfColors) * numberOfColors;

        return `chart-color-${regularColors[groupIndex]}`;
    };

    /**
     * filter out word indexes to use only numbered when need to automatically assign
     * colors to series.
     */
    helper.colorsList = _.filter(Object.keys(helper.numToString), function(index) {
        return !_.isNaN(+index);
    });

    //for collection metrics
    helper.totalSeriesTitles = {
        end_to_end: {
            title: l10nKeys.endToEndTimingTitle,
            color: 1,
        },
        se_throughput_by_vs: {
            title: l10nKeys.virtualServiceThroughputTitle,
            color: 7.2,
        },
        se_throughput_by_interface: {
            title: l10nKeys.interfaceThroughputTitle,
            color: 7,
        },
        vs_certificate_key_exchange: {
            title: l10nKeys.certificateTitle,
            color: 2,
        },
        certificate_pie_chart: {
            title: l10nKeys.certificateTitle,
            color: 2,
        },
        vs_ssl_tls_version: {
            title: l10nKeys.tlsVersionTitle,
            color: 3,
        },
        avg_ssl_connections: {
            title: l10nKeys.transactionsTitle,
            color: 2,
        },
        avg_ssl_errors: {
            title: l10nKeys.failedTransactionsTitle,
            color: 2,
        },
        vs_key_exchange: {
            title: l10nKeys.keyExchangeTitle,
            color: 3,
        },
        avg_attack_count: {
            title: l10nKeys.attackCountTitle,
            color: 3,
        },
        avg_attack_count_attack: {
            title: l10nKeys.attackRateTitle,
            color: 2,
        },
        avg_attack_count_ipgroup: {
            title: l10nKeys.attackRateTitle,
            color: 2,
        },
        avg_attack_count_url: {
            title: l10nKeys.attackRateTitle,
            color: 2,
        },
        avg_attack_count_asn: {
            title: l10nKeys.attackRateTitle,
            color: 2,
        },
        avg_attack_count_blocked: {
            title: l10nKeys.attackRateTitle,
            color: 2,
        },
        rx: {
            title: l10nKeys.rxMinusculesPacketsTitle,
        },
        tx: {
            title: l10nKeys.txMinusculesPacketsTitle,
        },
        dns_client_avg_complete_queries: {
            title: l10nKeys.dnsQueryTypesTitle,
            color: 4,
        },
        dns_client_avg_queries_by_type: {
            title: l10nKeys.tcpVsUdpTitle,
            color: 1,
        },
        dns_pass_through_or_locally: {
            title: l10nKeys.localVsPassthroughQueriesTitle,
            color: 3,
        },
        avg_ssl_pfs: {
            title: l10nKeys.pfsVsNonPfsTrafficTitle,
            color: 6,
        },
        http_1x_vs_2: {
            title: l10nKeys.httpVsHttps2RequestsTitle,
        },
        'icap_stats.avg_requests': {
            title: l10nKeys.icapRequestsTotalTitle,
            color: 4.2,
        },
        'bot.avg_all_bots': {
            title: l10nKeys.botTitle,
            color: 3,
        },
    };

    /**
     * to update labels list on fly when we have dynamic set of metrics and their Ids
     * group can be used to use NamesHelper to define different colors within a group
     * @param objHash {object} hash of objects to update/replace config objects at dictionary
     * {fullMetricId : {title: text, color: number, group: text}}
     *
     */
    helper.updateDict = function(objHash) {
        //number of items of that group to pick up next color from list of available colors
        const
            self = this,
            groupLengthDict = {};

        _.each(objHash, function(obj, index) {
            let colorIndex;

            if (!self.dict[index]) {
                if (!obj.color && obj.group) {
                    if (!groupLengthDict[obj.group]) {
                        groupLengthDict[obj.group] = _.filter(self.dict, function(cObj) {
                            return cObj.group && cObj.group === obj.group;
                        }).length;
                    }

                    if (groupLengthDict[obj.group] < self.colorsList.length) {
                        colorIndex = groupLengthDict[obj.group];
                    } else {
                        colorIndex = groupLengthDict[obj.group] % self.colorsList.length;
                    }

                    obj.color = self.colorsList[colorIndex];
                    groupLengthDict[obj.group]++;
                }

                self.dict[index] = obj;
            }
        });
    };

    /**
     * Removes some dynamically added titles from dictionary. Called by metrics object.
     * If group is provided, will delete only config having this particular group.
     * @param objHash {object} hash of objects to remove from dict {fullMetricId : {group: text}}
     */
    helper.removeFromDict = function(objHash) {
        const self = this;

        _.each(objHash, function(obj, index) {
            if (self.dict[index] && (!obj.group || obj.group === self.dict[index].group)) {
                delete self.dict[index];
            }
        });
    };

    /**
     * Returns a title text for the passed series names. Checks both hashes for defined title or
     * makes some basic transformations over it's name trying to get a human readable string out
     * of it.
     * @param {string} seriesName
     * @param {boolean=} noFallback - By design method is returning seriesName if nothing was
     *     found in dictionary. Passing true can switch it to return empty string when nothing
     *     was found.
     * @returns {string} - Series title text
     */
    helper.getTitle = function(seriesName, noFallback = false) {
        let title = '';

        if (seriesName && typeof seriesName === 'string') {
            if (seriesName in this.dict || seriesName.toLowerCase() in this.dict) {
                title = l10nService.getMessage((this.dict[seriesName] ||
                    this.dict[seriesName.toLowerCase()]).title);
            }

            if (!title && !noFallback) {
                const parts = seriesName.split('.');

                if (parts.length === 2) {
                    const notWanted = {
                        sum: true,
                        avg: true,
                        pct: true,
                    };

                    title = _.reduce(parts[1].split('_'), function(memo, s) {
                        if (!s.length) {
                            return;
                        }

                        // No pct, sum, avg
                        if (s in notWanted) {
                            return memo;
                        }

                        if (s in this.commonDict) {
                            return `${memo} ${this.commonDict[s]}`;
                        }

                        return memo + (memo ? ' ' : '') + s.slice(0, 1).toUpperCase() + s.slice(1);
                    }, '', this);
                } else {
                    title = seriesName;
                }
            }
        }

        return title;
    };

    /**
     * Looks up a color name to be used for chart's layout. Returns blue when not found.
     * @param {string} seriesName
     * @returns {string}
     */
    helper.getColorClass = function(seriesName) {
        const res = seriesName && typeof seriesName === 'string' &&
            this.totalSeriesTitles[seriesName] ||
            this.totalSeriesTitles[seriesName.toLowerCase()] ||
            this.dict[seriesName] || this.dict[seriesName.toLowerCase()];

        return `chart-color-${res && 'color' in res ? this.numToString[res.color] : 'blue'}`;
    };

    /**
     * Gets chartSettings of series.
     * @param  {string} name - Name of series.
     * @return {{}|null}
     */
    helper.getChartSettings = function(name) {
        const res = this.dict[name];

        return res && res.chartSettings ? angular.copy(res.chartSettings) : null;
    };

    /**
     * Returns a header string to show for the related metric representation.
     * @param {string} mName - {@link Metric#name}.
     * @returns {string|undefined}
     */
    helper.totalSeriesTitle = function(mName) {
        return this.totalSeriesTitles[mName] &&
            l10nService.getMessage(this.totalSeriesTitles[mName].title) || '';
    };

    return helper;
}]);
